(()=>{
const key='__rccFacebookV51';
if(window[key]){window[key](document);return;}
const seen=new WeakSet();
function init(scope){
const root=scope.matches?.('#dc-landing')?scope:scope.querySelector('#dc-landing');
if(!root||seen.has(root))return;seen.add(root);
/* Only carousel controls are interactive; social action labels are illustrative. */
root.querySelectorAll('[data-facebook-lazaros]').forEach(section => {
  const track = section.querySelector('.slc-facebook__track');
  const cards = [...track.querySelectorAll('.fb-post')];
  const dots = [...section.querySelectorAll('.slc-facebook__dot')];
  let current = 0;
  const update = () => {
    const left = track.getBoundingClientRect().left + 24;
    current = cards.reduce((best, card, i) => Math.abs(card.getBoundingClientRect().left-left) < Math.abs(cards[best].getBoundingClientRect().left-left) ? i : best, 0);
    dots.forEach((dot,i) => dot.setAttribute('aria-current', String(i === current)));
  };
  const go = index => {
    const i = (index + cards.length) % cards.length;
    const delta = cards[i].getBoundingClientRect().left - track.getBoundingClientRect().left - 24;
    track.scrollBy({left:delta,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
  };
  dots.forEach((dot,i) => dot.addEventListener('click', () => go(i)));
  section.querySelector('[data-fb-prev]').addEventListener('click', () => go(current-1));
  section.querySelector('[data-fb-next]').addEventListener('click', () => go(current+1));
  track.addEventListener('scroll', update, {passive:true});
  track.addEventListener('keydown', event => {if(['ArrowLeft','ArrowRight'].includes(event.key)){event.preventDefault();go(current+(event.key==='ArrowRight'?1:-1));}});
  window.addEventListener('resize', update);
  update();
});

}
window[key]=init;
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});}else{init(document);}
document.addEventListener('shopify:section:load',event=>init(event.target));
})();
